module.exports = __webpack_public_path__ + "static/img/setup_python-windows-install-path.119478e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/python/images/setup_python-windows-install-path.png
// module id = q06L
// module chunks = 1